import { useContext } from "react";
import { AuthContext } from "../auth";

function useAuth() {
  return useContext(AuthContext);
}

export default useAuth;
